import React, { useEffect, useState, Fragment } from "react"
import PageHeader from "../PageHeader"
import styled from "styled-components"
import { replaceWithSymbol } from "../../util/cutString"
// import { get, orderBy, find, filter, isArray, isEmpty } from "lodash"

import PrimaryButton from "../../components/buttons/PrimaryButton"
import { fetchData } from "../../store/action"
import { useDispatch, useSelector } from "react-redux"
import config from "../../Config"
import BidValue from "../../components/BidValue"
import i18n from "../../i18n"

const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  box-sizing: border-box;
`

const SuccessText = styled.p`
  font-family: montserratRegular;
  font-size: 19px;
  text-align: center;
  color: #dfe4ff;
`

const SummaryBox = styled.div`
  width: 100%;
  height: auto;
  margin: 32px 0;
  padding: 30px 35px;
  border-radius: 8px;
  box-sizing: border-box;
  text-align: left;
`
const SummaryTitle = styled.p`
  font-family: montserratRegular;
  font-size: 16px;
  font-weight: 500;
  color: #dfe4ff;
`

const SummaryDescription = styled.p`
  font-family: montserratLight;
  font-size: 14px;
  color: #dfe4ff;
  etter-spacing: 1px;
  line-height: 1.5;
`

const List = styled.div`
  margin-top: 25px;
`
const ListTitle = styled.p`
  font-family: montserratRegular;
  font-size: 14px;
  color: #dfe4ff;
`
const ListItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 5px 0;
  margin-bottom: 15px;
`

const Green = styled.div`
  width: 18px;
  height: 18px;
  background-color: #03c452;
  border-radius: 50%;
`
// const Orange = styled.div`
//   width: 18px;
//   height: 18px;
//   background-color: #f00;
//   border-radius: 50%;
// `
const Red = styled.div`
  width: 18px;
  height: 18px;
  background-color: #f00;
  border-radius: 50%;
`

const ListText = styled.p`
  font-family: montserratLight;
  font-size: 14px;
  color: #dfe4ff;
  margin: 0;
  padding-left: 10px;
`

const NoteBox = styled.div`
  width: 100%;
  margin: 18px 0;
  padding: 20px;
  border-radius: 8px;
  box-sizing: border-box;
  color: #522f00;
  font-family: montserratLight;
  font-size: 16px;
`

const SkipToHome = styled.button`
  background: transparent;
  font-family: "montserratRegular";
  cursor: pointer;
  border: none;
  outline: none;
  color: #fb0e56;
  text-transform: uppercase;
  font-size: 16px;
  margin: 24px 0 0;
`
const BidValuesWrapper = styled.div`
  padding-top: 15px;
  padding-bottom: 50px;
  padding-left: 15px;
  padding-right: 15px;
  display: inline;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
`

const BidPlacedSuccessfully = ({ history, match }) => {
  console.log("history", history)
  console.log("props", match)

  const [startBid, setStartBid] = useState(0)
  const [endBid, setEndBid] = useState(0)
  const [bids, setBids] = useState([])

  const dispatch = useDispatch()
  const theme = useSelector((state) => state.theme)
  console.log("bidPlacedSuccessfully", theme)

  useEffect(() => {
    dispatch(
      fetchData({
        // uniqueId,
        method: "GET",
        uri: `/userBids/${match.params.offerId}`,
        onSuccess: (res) => {
          // this.setState({ bidsRemaining: res.bidsRemaining || 0 })
          console.log("res", res.bidDetails)
          setBids(res.bidDetails)
        },
      })
    )
    dispatch(
      fetchData({
        // uniqueId,
        method: "GET",
        uri: `/zone?offerId=${match.params.offerId}`,
        onSuccess: (res) => {
          setStartBid(res.safeZoneStart)
          setEndBid(res.safeZoneEnd)
          // this.setState({ startBid: res.safeZoneStart }),
          //   this.setState({ endBid: res.safeZoneEnd })
        },
      })
    )
  }, [])

  const offerTitle = match.params.title
  const offerId = match.params.offerId

  const bidsSelected =
    history.location.state && history.location.state.bidsArray
  const bidsSelectedLength = bidsSelected.length
  // const myBids = [...bids]
  const myBidsData = bids.slice(0, bidsSelectedLength)
  return (
    <Fragment>
      <PageHeader
        backLocation={`/play/place-bids/${replaceWithSymbol(
          offerTitle
        )}/${offerId}`}
        label={""}
        theme={theme}
      />
      <Container style={{ backgroundColor: theme.secondaryColor }}>
        <img
          src={`${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/other-icons/success.webp`}
        />
        <SuccessText>{i18n.t("BidsPlacedSuccessfully")}</SuccessText>

        <SummaryBox style={{ backgroundColor: theme.cardColor }}>
          <SummaryTitle>{i18n.t("UserBidSummary")}</SummaryTitle>
          <SummaryDescription>{i18n.t("ListOfBids")}</SummaryDescription>
          <BidValuesWrapper
            style={{
              justifyContent: myBidsData.length > 5 ? "center" : "flex-start",
            }}
          >
            {myBidsData.map((obj, index) => {

              console.log("OBJ ", obj)
              
              const updatedBidHealth = obj.bidHealth === "okBid" ? "badBid" : obj.bidHealth;
              return (
                <BidValue
                  key={index}
                  number={obj.bidValue}
                  className={updatedBidHealth}
                />
              )
            })}
          </BidValuesWrapper>
          <List>
            <ListTitle>{i18n.t("ColourLegends")}: </ListTitle>
            <ListItem>
              <Green />
              <ListText>
                {i18n.t("GreenIs")} <b>{i18n.t("Good")}</b> {i18n.t("Bid")}
                {console.log("oky bid GreenIs")}
              </ListText>
            </ListItem>
            {/* <ListItem>
              <Orange />
              <ListText>
                {i18n.t("OrangeIs")} <b>{i18n.t("Okay")}</b> {i18n.t("Bid")}
                {console.log("oky bid orange")}
              </ListText>
            </ListItem> */}
            <ListItem>
              <Red />
              <ListText>
                {i18n.t("RedIs")} <b>{i18n.t("Bad")}</b> {i18n.t("Bid")}
              </ListText>
            </ListItem>
          </List>
        </SummaryBox>
        <NoteBox style={{ backgroundColor: theme.highlightBorderColor }}>
          {i18n.t("PlaceBidsBetween")} <b>{startBid}</b> {i18n.t("And")}{" "}
          <b>{endBid}</b> {i18n.t("ImproveWinningChances")}
        </NoteBox>
        <PrimaryButton
          label='PlaceMoreBids'
          variant='contained'
          style={{
            borderRadius: "30px",
            backgroundColor: theme.primaryButtonColor,
            // maxWidth: "280px",
            width: "90%",
            height: "56px",
            marginTop: "24px",
            textTransform: "uppercase",
          }}
          onClick={() => {
            history.push(
              `/play/place-bids/${replaceWithSymbol(offerTitle)}/${offerId}`
            )
          }}
        />
        <SkipToHome onClick={() => history.push("/play/")}>
          {i18n.t("SkipToHome")}
        </SkipToHome>
      </Container>
    </Fragment>
  )
}

export default BidPlacedSuccessfully



// WEBPACK FOOTER //
// ./src/views/BidPlacedSuccessfully/BidPlacedSuccessfully.js